import { render, staticRenderFns } from "./LiteratureView.vue?vue&type=template&id=c354f7be&scoped=true&"
import script from "./LiteratureView.vue?vue&type=script&lang=js&"
export * from "./LiteratureView.vue?vue&type=script&lang=js&"
import style0 from "./LiteratureView.vue?vue&type=style&index=0&id=c354f7be&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c354f7be",
  null
  
)

export default component.exports